import { SET_SELECTED_COLUMN } from "constants/syncInput";

export default (state = "", action) => {
  switch (action.type) {
    case SET_SELECTED_COLUMN:
      return action.value;
    default:
      return state;
  }
};
